import { connect } from 'react-redux';
import ViewDriveItemPage from '../../components/ViewDriveItemPage';

export default connect()(ViewDriveItemPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ViewDriveItemPage/index.tsx